import { ROLES } from '../../../../../constants';

import Projects from '../../v2/components/one/project/projects-list/projects';
import Project from '../../v2/components/one/project/project-chat/index';
import UpsertProject from '../../v2/components/one/project/upsert-project';
import Milestone from '../../v2/components/one/project/milestone';
import ProjectDetails from '../../v2/components/one/project/project-details';
// import CustomersOne from '../../v2/components/one/reference-data/customer/customer';
// import Contacts from '../../v2/components/one/reference-data/contacts/contacts';
// import ArticleOne from '../../v2/components/one/reference-data/article/article';
// import PartOne from '../../v2/components/one/reference-data/part/part';
// import MachineOne from '../../v2/components/one/reference-data/machine/machine';

import NewProjectTemplate from '../../v2/components/form-template/upsert-templates/project/new-template';
import EditProjectTemplate from '../../v2/components/form-template/upsert-templates/project/edit-template';
import CopyProjectTemplate from '../../v2/components/form-template/upsert-templates/project/copy-template';

import ProjectTemplates from '../../v2/components/form-template/templates-list/project-templates';
import MilestoneGroups from '../../v2/components/one/project/milestone-groups/list.vue';
import UpsertMilestoneGroups from '../../v2/components/one/project/milestone-groups/upsert-group.vue';
import FieldDetails from '../../v2/components/form-template/upsert-templates/common/field-details';

import { LICENSE_MODULES } from '../../../../../constants';

export default [
  {
    path: '/',
    name: 'home',
    redirect: '/dashboard',
    meta: {
      title: '',
      requiresAuth: true,
      module: LICENSE_MODULES.ONE,
      roles: '*',
    },
  },
  // {
  //   path: '/one/article',
  //   name: 'articleOne',
  //   component: ArticleOne,
  //   meta: {
  //     title: 'Article',
  //     requiresAuth: true,
  //     module: 'One',
  //     roles: '*',
  //   },
  // },
  // {
  //   path: '/one/parts',
  //   name: 'partOne',
  //   component: PartOne,
  //   meta: {
  //     title: 'Part',
  //     requiresAuth: true,
  //     module: 'One',
  //     roles: '*',
  //   },
  // },
  // {
  //   path: '/one/machines',
  //   name: 'machineOne',
  //   component: MachineOne,
  //   meta: {
  //     title: 'Machine',
  //     requiresAuth: true,
  //     module: 'One',
  //     roles: '*',
  //   },
  // },
  // {
  //   path: '/one/customers',
  //   name: 'customersOne',
  //   component: CustomersOne,
  //   meta: {
  //     title: 'Customers',
  //     requiresAuth: true,
  //     module: 'One',
  //     roles: '*',
  //   },
  // },
  // {
  //   path: '/one/contacts',
  //   name: 'contacts',
  //   component: Contacts,
  //   meta: {
  //     title: 'Contacts',
  //     requiresAuth: true,
  //     module: 'One',
  //     roles: '*',
  //   },
  // },
  {
    path: '/one/projects',
    name: 'projects',
    component: Projects,
    meta: {
      title: 'Projects',
      requiresAuth: true,
      module: 'One',
      roles: '*',
    },
  },
  {
    path: '/one/content-templates',
    name: 'content-templates',
    component: ProjectTemplates,
    meta: {
      title: 'Content Templates',
      requiresAuth: true,
      module: 'One',
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.SUPERUSER],
    },
  },
  {
    path: '/one/milestone-groups',
    name: 'milestone-groups',
    component: MilestoneGroups,
    meta: {
      title: 'Milestone groups',
      requiresAuth: true,
      module: 'One',
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.SUPERUSER],
    },
  },
  {
    path: '/one/create-milestone-group',
    name: 'create-milestone-group',
    component: UpsertMilestoneGroups,
    meta: {
      title: 'Create Milestone Groups',
      requiresAuth: true,
      module: 'One',
      roles: '*',
      isGoBackBtn: true,
    },
  },
  {
    path: '/one/milestone-group/:id',
    name: 'milestone-group',
    component: UpsertMilestoneGroups,
    meta: {
      title: 'Milestone Groups Details',
      requiresAuth: true,
      module: 'One',
      roles: '*',
    },
  },
  {
    path: '/one/new-content-template/:id',
    name: 'new-content-template',
    component: NewProjectTemplate,
    meta: {
      title: 'New Content Template',
      requiresAuth: true,
      module: 'One',
      roles: '*',
    },
  },
  {
    path: '/one/new-content-template/:id/field-details',
    name: 'content-field-details',
    component: FieldDetails,
    meta: {
      title: 'Field details',
      requiresAuth: true,
      module: 'One',
      roles: '*',
    },
  },
  {
    path: '/one/copy-content-template/:id',
    name: 'copy-content-template',
    component: CopyProjectTemplate,
    meta: {
      title: 'New Content Template',
      requiresAuth: true,
      module: 'One',
      roles: '*',
    },
  },
  {
    path: '/one/content-templates/:id/edit',
    name: 'edit-content-template',
    component: EditProjectTemplate,
    meta: {
      title: 'Edit Content Template',
      requiresAuth: true,
      module: 'One',
      roles: '*',
    },
  },
  {
    path: '/one/project/:id/milestone/:milestoneId',
    name: 'milestone',
    component: Milestone,
    meta: {
      title: 'Milestone',
      requiresAuth: true,
      module: 'One',
      roles: '*',
    },
  },
  {
    path: '/one/project/:id/project-details/:milestoneId',
    name: 'project-details-on-site-support-only',
    component: ProjectDetails,
    meta: {
      title: 'Project Details',
      requiresAuth: true,
      module: 'One',
      roles: '*',
    },
  },
  {
    path: '/one/project/:id',
    name: 'project',
    component: Project,
    meta: {
      title: 'Project',
      requiresAuth: false,
      module: 'One',
      roles: '*',
    },
  },
  {
    path: '/one/project-details/:id',
    name: 'project-details',
    component: UpsertProject,
    meta: {
      title: 'Project Details',
      requiresAuth: true,
      module: 'One',
      roles: '*',
    },
  },
  {
    path: '/one/meeting-room/:meeting',
    name: 'meeting-room',
    component: Project,
    meta: {
      title: 'Meeting room',
      requiresAuth: true,
      module: 'One',
      roles: '*',
    },
  },
  {
    path: '/one/new-project/:id',
    name: 'new-project',
    component: UpsertProject,
    meta: {
      title: 'New Project',
      requiresAuth: true,
      module: 'One',
      roles: '*',
    },
  },
];
